// initial state
const state = () => ({
  apiToken: '',
  loading: false,
  modal: false,
  modalPrint: false,
  modalLog: false,
  alertModal: false,
  modalDetalhes: false,
  modalEdicao: false,
  modalBalanco: false,
  modalMnemonicos: false,
  campoAlterantivoEdit: null,
  modalFormPersonalCampo: false,
  modalBalancoOsPorProduto: false,
  percentual: 0,
  modalDesconto: false,
  modalCalendario: false,
  textoLoading: '',
  modalBalancoPDL: false,
  modalBoletoPDL: false,
  modalEditColumns: false,
  modalMnemonicosSitContratos: false,
  modalLogin: false,
});

// getters
const getters = {};

// mutations
const mutations = {
  loading(_state) {
    _state.loading = true;
  },
  loaded(_state) {
    _state.loading = false;
    _state.textoLoading = '';
    _state.percentual = 0;
  },
  openModal(_state) {
    _state.modal = true;
  },
  closeModal(_state) {
    _state.modal = false;
  },
  openModalPrint(_state) {
    _state.modalPrint = true;
  },
  closeModalPrint(_state) {
    _state.modalPrint = false;
  },
  openModalDetalhes(_state) {
    _state.modalDetalhes = true;
  },
  closeModalDetalhes(_state) {
    _state.modalDetalhes = false;
  },
  openModalLog(_state) {
    _state.modalLog = true;
  },
  closeModalLog(_state) {
    _state.modalLog = false;
  },
  setApiToken(_state, token) {
    _state.apiToken = token;
  },
  openAlert(_state) {
    _state.alertModal = true;
  },
  closeAlert(_state) {
    _state.alertModal = false;
  },
  openModalEdicao(_state) {
    _state.modalEdicao = true;
  },
  closeModalEdicao(_state) {
    _state.modalEdicao = false;
  },
  atualizarPercentual(_state, { percentual }) {
    _state.percentual = percentual;
  },
  atualizarTextoLoading(_state, { texto }) {
    _state.textoLoading = texto;
  },
  openModalBalanco(_state) {
    _state.modalBalanco = true;
  },
  closeModalBalanco(_state) {
    _state.modalBalanco = false;
  },
  setCampoAlternativo(_state, tabela) {
    _state.campoAlterantivoEdit = tabela;
  },
  openModalFormPersonalCampo(_state) {
    _state.modalFormPersonalCampo = true;
  },
  closeModalFormPersonalCampo(_state) {
    _state.modalFormPersonalCampo = false;
  },
  openModalMnemonicos(_state) {
    _state.modalMnemonicos = true;
  },
  closeModalMnemonicos(_state) {
    _state.modalMnemonicos = false;
  },
  openModalBalancoOsPorProduto(_state) {
    _state.modalBalancoOsPorProduto = true;
  },
  closeModalBalancoOsPorProduto(_state) {
    _state.modalBalancoOsPorProduto = false;
  },
  openModalDesconto(_state) {
    _state.modalDesconto = true;
  },
  closeModalDesconto(_state) {
    _state.modalDesconto = false;
  },
  openModalCalendario(_state) {
    _state.modalCalendario = true;
  },
  closeModalCalendario(_state) {
    _state.modalCalendario = false;
  },
  openModalBalancoPDL(_state) {
    _state.modalBalancoPDL = true;
  },
  closeModalBalancoPDL(_state) {
    _state.modalBalancoPDL = false;
  },
  openModalBoletoPDL(_state) {
    _state.modalBoletoPDL = true;
  },
  closeModalBoletoPDL(_state) {
    _state.modalBoletoPDL = false;
  },
  openModalEditColumns(_state) {
    _state.modalEditColumns = true;
  },
  closeModalEditColumns(_state) {
    _state.modalEditColumns = false;
  },
  openModalMnemonicosSitContratos(_state) {
    _state.modalMnemonicosSitContratos = true;
  },
  closeModalMnemonicosSitContratos(_state) {
    _state.modalMnemonicosSitContratos = false;
  },
  openModaLogin(_state) {
    _state.modalLogin = true;
  },
  closeModalLogin(_state) {
    _state.modalLogin = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
